module.exports = __webpack_public_path__ + "static/media/logout.681fc00c.svg";